/* urbanhive.js — rev 2026-08-01a (Sync-Trigger) */
// window resize
var mobileWidthLimit = 768;

function updateWindowChange() {
  var heroText = document.getElementsByClassName("hero__text-content")[0];
  if (heroText) {
    if (window.innerWidth < mobileWidthLimit) {
      heroText.classList.remove("vertical-center");
      heroText.classList.remove("horizontal-left");
      heroText.classList.add("vertical-top");
      heroText.classList.add("horizontal-center");
    } else {
      heroText.classList.add("vertical-center");
      heroText.classList.add("horizontal-left");
      heroText.classList.remove("vertical-top");
      heroText.classList.remove("horizontal-center");
    }
  }
}

window.addEventListener('resize', updateWindowChange);
updateWindowChange();

// Product details Section
var tabHorizontalBtnList = document.getElementsByClassName('tab-horizontal-btn');
var tabHorizontalContentWrapperList = document.getElementsByClassName('tab-horizontal-content-wrapper');

for (var i = 0; i < tabHorizontalBtnList.length; i++) {

  tabHorizontalBtnList[i].addEventListener("click", function (event) {
    var valueBtn = event.target.getAttribute("tab-btn-id");

    for (var i = 0; i < tabHorizontalBtnList.length; i++) {
      var value = tabHorizontalBtnList[i].getAttribute("tab-btn-id");
      if (valueBtn == value) {
        tabHorizontalBtnList[i].classList.add("tab-btn-selected");
      } else {
        tabHorizontalBtnList[i].classList.remove("tab-btn-selected");
      }
    }

    for (var i = 0; i < tabHorizontalContentWrapperList.length; i++) {
      var valueContent = tabHorizontalContentWrapperList[i].getAttribute("tab-content-id");
      if (valueBtn != valueContent) {
        tabHorizontalContentWrapperList[i].classList.add("tab-content-invisible");
      } else {
        tabHorizontalContentWrapperList[i].classList.remove("tab-content-invisible");
      }
    }
  });

}

function roundUpToTwoDecimals(number) {
  // Multipliziere mit 100, um die Dezimalstellen in den Ganzzahlbereich zu bringen
  let multiplied = number * 100;
  // Runde immer auf die nächsthöhere Ganzzahl auf
  let roundedUp = Math.ceil(multiplied);
  // Teile durch 100, um wieder auf zwei Dezimalstellen zurückzugehen
  return roundedUp / 100;
}

// popup Video
function run() {
  return new Promise((resolve, reject) => {
    //the task is going to take 2 seconds to be completed or it doesn’t matter we can wait for it’s completion
    setTimeout(() => {
      resolve();
    }, 10000);
  });
}

run().then(() => {
  var popupVideoButton = document.getElementsByClassName('videoask-embed__button_bottom--1dnRy')[0];
  if (popupVideoButton != null) {
    popupVideoButton.style.setProperty('display', 'flex', 'important');
  }
});

// toggle bundle details
function toggleBundleDetailsContainer(toggleButton) {
  var chevron = toggleButton.children[0];
  var bundleDetailsContainer = toggleButton.nextElementSibling;
  var containerHeight = bundleDetailsContainer.scrollHeight + "px";
  if (containerHeight.localeCompare(bundleDetailsContainer.style.maxHeight) <= 0) {
    bundleDetailsContainer.style.maxHeight = 0;
    chevron.style.transform = null;
  } else {
    bundleDetailsContainer.style.maxHeight = containerHeight;
    chevron.style.transform = "rotate(180deg)";
  }
}

// scroll to bottom
const scrollBtnList = document.getElementsByClassName('scroll-to-bottom');
for (var i = 0; i < scrollBtnList.length; i++) {
  var scrollBtn = scrollBtnList[i];
  scrollBtn.addEventListener('click', () => window.scrollTo({
    top: 999999,
    behavior: 'smooth',
  }));
}

function navigateToHash(hashLink) {
  window.location.hash = hashLink;
}

// variant change
function variantChange(e) {
  var variantId = "";
  if (e.detail && e.detail.variant && e.detail.variant.id) {
    variantId = e.detail.variant.id + "";
  } else if (e.srcElement.baseURI.includes("variant=")) {
    const urlObj = new URL(e.srcElement.baseURI);
    const params = new URLSearchParams(urlObj.search);
    variantId = params.get("variant");
  } else {
    var variantList = document.getElementsByClassName("product-form__option-selector");
    if (variantList.length > 0) {
      variantId = variantList[0].attributes['data-variant-id'].value;
    }
  }

  // change description // TODO
  var list_beschreibung = document.getElementsByClassName("variant-beschreibung");
  for (var i = 0; i < list_beschreibung.length; i++) {
    if (list_beschreibung[i]) {
      list_beschreibung[i].style.display = "none";
    }
  }
  var variant_beschreibung = document.getElementById("variant-beschreibung-" + variantId);
  if (variant_beschreibung) {
    variant_beschreibung.style.display = "block";
  }

  // change savings
  var list_savings = document.getElementsByClassName("variant-savings");
  for (var i = 0; i < list_savings.length; i++) {
    if (list_savings[i]) {
      list_savings[i].style.display = "none";
    }
  }
  var variant_savings = document.getElementById("variant-savings-" + variantId);
  if (variant_savings) {
    variant_savings.style.display = "block";
  }

  // change delivery scope
  var list_lieferumfang = document.getElementsByClassName("variant-lieferumfang");
  for (var i = 0; i < list_lieferumfang.length; i++) {
    if (list_lieferumfang[i]) {
      list_lieferumfang[i].style.display = "none";
    }
  }
  var variant_lieferumfang = document.getElementById("variant-lieferumfang-" + variantId);
  if (variant_lieferumfang) {
    variant_lieferumfang.style.display = "block";
  }

  updateDeliveryTime(variantId);
}

// Lieferzeit (Metafield custom.lieferzeit): Variante vor Produkt, sonst ausblenden.
// Aufgerufen bei jedem Variantenwechsel (Theme-Picker ueber variantChange,
// Multi-Step-Picker ueber das Event urbanhive:variant). Es kann mehrere Bloecke
// je Seite geben (Multi-Step-Picker rendert je Schritt einen).
function updateDeliveryTime(variantId) {
  if (!variantId) {
    return;
  }
  var deliveryBlocks = document.querySelectorAll("[data-product-delivery-time]");
  for (var b = 0; b < deliveryBlocks.length; b++) {
    var block = deliveryBlocks[b];
    var variantRows = block.getElementsByClassName("variant-lieferzeit");
    for (var i = 0; i < variantRows.length; i++) {
      variantRows[i].style.display = "none";
    }
    var variantRow = block.querySelector('.variant-lieferzeit[data-variant-id="' + variantId + '"]');
    var productRow = block.querySelector(".product-lieferzeit");
    if (variantRow) {
      variantRow.style.display = "inline";
      if (productRow) {
        productRow.style.display = "none";
      }
      block.style.display = "";
    } else if (productRow) {
      productRow.style.display = "inline";
      block.style.display = "";
    } else {
      block.style.display = "none";
    }
  }
}
document.addEventListener("urbanhive:variant", function (e) {
  updateDeliveryTime(e.detail && e.detail.variantId ? e.detail.variantId + "" : "");
});
window.addEventListener("onload", variantChange);
window.addEventListener("change", variantChange);
window.addEventListener("DOMContentLoaded", variantChange);
document.addEventListener("variant:change", variantChange);

/** Add styles for LockOn-App **/
// document.addEventListener('DOMContentLoaded', function() {
//   var mainContent = document.getElementById('MainContent');
//   var passcodeDiv = mainContent.querySelector('#passcode');

//   if (passcodeDiv) {
//     mainContent.classList.add('has-passcode');
//     var innerHead = passcodeDiv.querySelector('#innerForm h3');
//     innerHead.innerHTML = "Secret Sale";
//     var innerLabel = passcodeDiv.querySelector('#innerForm label');
//     innerLabel.innerHTML = "Gib das Passwort ein, um den Zugang zum Secret Sale freizuschalten:";
//     var innerBtn = passcodeDiv.querySelector('#innerForm button');
//     innerBtn.innerHTML = "Freischalten";
//     var innerError = passcodeDiv.querySelector('#innerForm span');
//     innerError.innerHTML = "Falsches Passwort!";
//   }
// });

/* == Lazy-Loading für Below-fold-Videos ====================================
   Sections ab Position 3 rendern <video data-lazy-src> bzw. <source data-lazy-src>
   mit preload="none". Erst wenn das Video in Sichtweite scrollt (300px Vorlauf),
   wird die Quelle gesetzt, geladen und - bei data-lazy-play - abgespielt. */
(function () {
  'use strict';

  var candidates = [];
  document.querySelectorAll('video[data-lazy-src]').forEach(function (v) { candidates.push(v); });
  document.querySelectorAll('video source[data-lazy-src]').forEach(function (srcEl) {
    var v = srcEl.closest('video');
    if (v && candidates.indexOf(v) === -1) candidates.push(v);
  });
  if (!candidates.length) return;

  function activate(video) {
    if (video.dataset.lazySrc) {
      video.src = video.dataset.lazySrc;
      video.removeAttribute('data-lazy-src');
    }
    video.querySelectorAll('source[data-lazy-src]').forEach(function (srcEl) {
      srcEl.src = srcEl.dataset.lazySrc;
      srcEl.removeAttribute('data-lazy-src');
    });
    video.load();
    if (video.hasAttribute('data-lazy-play')) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  if (!('IntersectionObserver' in window)) {
    candidates.forEach(activate);
    return;
  }

  // Laden mit 300px Vorlauf (Buffering), Abspielen erst bei echter Sichtbarkeit -
  // so konkurriert kein unsichtbares Video mit dem LCP um Bandbreite.
  var playIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      playIo.unobserve(entry.target);
      var p = entry.target.play();
      if (p && p.catch) p.catch(function () {});
    });
  });

  var loadIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      loadIo.unobserve(entry.target);
      var video = entry.target;
      var shouldPlay = video.hasAttribute('data-lazy-play');
      video.removeAttribute('data-lazy-play');
      activate(video);
      if (shouldPlay) playIo.observe(video);
    });
  }, { rootMargin: '300px 0px' });

  // Erst nach dem vollständigen Seiten-Load beobachten, damit der initiale
  // Renderpfad (LCP) nicht mit Video-Downloads konkurriert.
  var arm = function () { candidates.forEach(function (v) { loadIo.observe(v); }); };
  if (document.readyState === 'complete') {
    arm();
  } else {
    window.addEventListener('load', arm);
  }
})();

/* == Hero-/Hintergrund-Videos: Player-Controls dauerhaft unterbinden ========
   theme.js setzt bei blockiertem Autoplay das controls-Attribut als Fallback -
   in den Video-Sections sollen aber niemals Overlays (Play/Pause/Springen)
   erscheinen. Attribut daher sofort wieder entfernen, sobald es auftaucht. */
(function () {
  'use strict';

  var videos = document.querySelectorAll('.video-parent-section video');
  if (!videos.length) return;

  videos.forEach(function (v) {
    v.removeAttribute('controls');
    v.controls = false;
    new MutationObserver(function () {
      if (v.hasAttribute('controls')) {
        v.removeAttribute('controls');
        v.controls = false;
      }
    }).observe(v, { attributes: true, attributeFilter: ['controls'] });
  });
})();
